import z from "zod";

import { type ErrorDetails, RemiHttpCode } from "./remi-app";

const oddjobApiErrorTypeValues = [
  "EMPTY_PDF_FILE",
  "FILE_NOT_FOUND",
  "FILE_NOT_READABLE",
  "PDF_PARSING_NOT_SUPPORTED",
  "TEST_ERROR",
] as const;

const oddjobApiErrorTypeSchema = z.enum(oddjobApiErrorTypeValues);
const OddjobApiErrorType = oddjobApiErrorTypeSchema.enum;
type OddjobApiErrorType = z.infer<typeof oddjobApiErrorTypeSchema>;

export type OddjobApiErrors =
  | {
      errorType: typeof OddjobApiErrorType.EMPTY_PDF_FILE;
      data: { fileId: string };
    }
  | {
      errorType: typeof OddjobApiErrorType.FILE_NOT_FOUND;
      data: { fileId: string };
    }
  | {
      errorType: typeof OddjobApiErrorType.FILE_NOT_READABLE;
      data: { fileId: string };
    }
  | {
      errorType: typeof OddjobApiErrorType.PDF_PARSING_NOT_SUPPORTED;
      data: { partnerFlow: string };
    }
  | {
      errorType: typeof OddjobApiErrorType.TEST_ERROR;
      data: undefined;
    };

export const oddjobApiErrorDetails: Record<OddjobApiErrorType, ErrorDetails> = {
  [OddjobApiErrorType.EMPTY_PDF_FILE]: {
    sentryDescription: "Downloaded estimate PDF was empty (zero bytes)",
    remiHttpCode: RemiHttpCode.BAD_REQUEST,
  },
  [OddjobApiErrorType.FILE_NOT_FOUND]: {
    sentryDescription: "File not found when parsing estimate PDF",
    remiHttpCode: RemiHttpCode.NOT_FOUND,
  },
  // Split from FILE_NOT_FOUND so the two group separately: the fingerprint keys on errorType.
  [OddjobApiErrorType.FILE_NOT_READABLE]: {
    sentryDescription: "Estimate PDF file exists but is not readable",
    remiHttpCode: RemiHttpCode.NOT_FOUND,
  },
  [OddjobApiErrorType.PDF_PARSING_NOT_SUPPORTED]: {
    sentryDescription: "PDF parsing not supported for this partner flow",
    remiHttpCode: RemiHttpCode.BAD_REQUEST,
  },
  [OddjobApiErrorType.TEST_ERROR]: {
    sentryDescription: "Test error for verifying error handling",
    remiHttpCode: RemiHttpCode.INTERNAL_SERVER_ERROR,
  },
};
